<template>
  <div id="app">
    <div class="welcome" v-if="!hasPiggy">
      <h1>Piggy</h1>
      <p>Wer macht eine Piggy?</p>
      <p>Du möchtest eine Piggy!</p>
      <button @click.left="getPiggy">Piggy! Piggy!</button>
    </div>
    <!--
    <div class="" v-if="!piggy.name">
      <p>Der Name lautet</p>
      <input/>
    </div>
    -->
    <div class="bg" v-if="hasPiggy">
      <div class="piggy"></div>
      <div class="speechBubble">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data: function () {
    return {
      hasPiggy: false,
      text: '...',
      allText: [
        'Quiek, Quiek',
        '*grunz*',
        'Oink, Oink, Oink!',
        'Quiiiiek',
        'Qui?',
        'Quiek'
      ]
    }
  },
  created: function () {
    this.getText();
  },
  methods: {
    getPiggy: function () {
      this.hasPiggy = true;
    },
    getText: function () {
      setInterval(function () {
        var number = this.getRandom(0, this.allText.length - 1);
        this.text = this.allText[number];
      }.bind(this), 1500);
    },
    getRandom: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }
}
</script>

<style src="./scss/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue